// startRotate.js
var StartRotate = pc.createScript('startRotate');

// initialize code called once per entity
StartRotate.prototype.initialize = function() {
    
    this.app.on('systemGenerator:reset', this.setRotation, this);
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.theSeed);
    this.setRotation();
};

StartRotate.prototype.setRotation = function() {
    
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.theSeed + this.entity._guid);

    var x = Math.floor(this.randomize()*360);
    var y = Math.floor(this.randomize()*360);
    var z = Math.floor(this.randomize()*360);
    var all = new pc.Vec3(x,y,z);

    this.entity.setLocalEulerAngles(all);
    if(this.randomize() > 0.0){
        this.entity.enabled = true;
    } else {
        this.entity.enabled = false;
    }
};

// update code called every frame
StartRotate.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// StartRotate.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

